import SecaoPessoal from './SecaoPessoal';
import SecaoIdiomas from './SecaoIdiomas';
import SecaoExperienciasAnteriores from './SecaoExperienciasAnteriores';
import { SECAO_DOSSIE_COLABORADOR } from 'src/utils/constants';
import SecaoAutorizacaoDivulgacaoAniversario from './SecaoAutorizacaoDivulgacaoAniversario';
import SecaoDisponibilidadeMudanca from './SecaoDisponibilidadeMudanca';
import SecaoInteresseOutrasAreas from './SecaoInteresseOutrasAreas';
import SecaoCursosExtracurriculares from './SecaoCursosExtracurriculares';
import SecaoFormacoesAcademicas from './SecaoFormacoesAcademicas';
import SecaoOutros from './SecaoOutros';

const sectionsRegistry = {
  [SECAO_DOSSIE_COLABORADOR.PESSOAL]: SecaoPessoal,
  [SECAO_DOSSIE_COLABORADOR.FORMACOES_ACADEMICAS]: SecaoFormacoesAcademicas,
  [SECAO_DOSSIE_COLABORADOR.IDIOMAS]: SecaoIdiomas,
  [SECAO_DOSSIE_COLABORADOR.EXPERIENCIAS_ANTERIORES]:
    SecaoExperienciasAnteriores,
  [SECAO_DOSSIE_COLABORADOR.CURSOS_EXTRACURRICULARES]:
    SecaoCursosExtracurriculares,
  [SECAO_DOSSIE_COLABORADOR.AUTORIZACAO_DIVULGACAO_ANIVERSARIO]:
    SecaoAutorizacaoDivulgacaoAniversario,
  [SECAO_DOSSIE_COLABORADOR.DISPONIBILIDADE_MUDANCA]:
    SecaoDisponibilidadeMudanca,
  [SECAO_DOSSIE_COLABORADOR.INTERESSE_OUTRAS_AREAS]: SecaoInteresseOutrasAreas,
  [SECAO_DOSSIE_COLABORADOR.OUTROS]: SecaoOutros,
};

export default sectionsRegistry;
